var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPesoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.535,
    height: 19.872,
    viewBox: "0 0 18.535 19.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "peso_icon",
    transform: "translate(-2.862 -1.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_104",
    "data-name": "Tracciato 104",
    d: "M28.779,30.37H16.342L13.29,42.543l1.307,3.1H30.518l1.307-3.1Z",
    transform: "translate(-10.428 -24.212)",
    fill: "#a0a7bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_105",
    "data-name": "Tracciato 105",
    d: "M47.2,7a2.986,2.986,0,1,0,2.115.872A2.988,2.988,0,0,0,47.2,7Zm0,4.869a1.881,1.881,0,1,1,1.881-1.881A1.881,1.881,0,0,1,47.2,11.869Z",
    transform: "translate(-35.074 -5.444)",
    fill: "#a0a7bb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesoIcon);
export default __webpack_public_path__ + "static/media/peso_icon.789b471ed5b6965987630e1dd32e799e.svg";
export { ForwardRef as ReactComponent };